import { render } from "./ContractDetails.vue?vue&type=template&id=6d115625&scoped=true"
import script from "./ContractDetails.vue?vue&type=script&lang=js"
export * from "./ContractDetails.vue?vue&type=script&lang=js"

import "./ContractDetails.vue?vue&type=style&index=0&id=6d115625&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d115625"]])

export default __exports__